import "@/styles/chatWidgetStyles.css";
import PageLayout from "../ui/PageLayout.jsx";
import { Button } from "@/components/ui/button";
import { BookOpen } from "lucide-react";
import { CrispChat } from "@/ui/CrispChat";
import { UserRoleClaim } from "supertokens-auth-react/recipe/userroles";
import Session from "supertokens-auth-react/recipe/session";

function Support() {
  const claimValue = Session.useClaimValue(UserRoleClaim);
  const userRoles = claimValue.value;
  const isPro = Array.isArray(userRoles) && userRoles.includes("pro");
  return (
    <PageLayout
      heading="Support"
      description="Feel free to read our documentation, chat with us, or schedule a call if you need further assistance."
    >
      <div className="flex gap-4 mb-8">
        <Button
          variant="outline"
          onClick={() => {
            window.open("https://docs.samsearch.co", "_blank");
          }}
          className="w-full"
        >
          <BookOpen />
          Read Docs
        </Button>
        <CrispChat className="w-full" />
      </div>
      {/* Calendar Embed Section */}
      {isPro && (
        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-2">Schedule a Meeting</h2>
          <p className="mb-4">
            If you'd prefer to speak directly with a member of our team, you can
            easily book a time that works for you using the calendar below.
          </p>
          <div className="zcal-embed-container">
            <iframe
              src="https://zcal.co/i/Pb2zwJl0?embed=1&embedType=iframe"
              loading="lazy"
              style={{
                border: "none",
                width: "100%",
                height: "900px",
                maxWidth: "1096px",
              }}
              id="zcal-invite"
              scrolling="no"
            />
          </div>
        </div>
      )}
    </PageLayout>
  );
}

export default Support;
